<template>
  <!-- APP BAR -->
  <v-app-bar density="compact" class="appBar">
    <div class="appBarContent">

      <!-- LINKS -->
      <div class="leftSideContent">
        <v-app-bar-nav-icon
          variant="text"
          @click.stop="drawer = !drawer"
        />
        <img
          class="INP-Logo"
          :src="headerLogo"
          alt="Logo"
        />
      </div>

      <!-- RECHTS -->
      <div class="rightSideContent">
        <v-btn icon="mdi-email-open-outline" />

        <v-btn
          icon="mdi-account-outline"
          @click.stop.prevent="toggleAccountDrawer"
        />

        <v-btn
          class="btn_Logout"
          prepend-icon="mdi-logout"
          @click="logout"
        >
          Logout
        </v-btn>

        <!-- DARK MODE SCHALTER -->
        <v-switch
          v-model="isDark"
          inset
          hide-details
          density="compact"
          class="theme-switch"
        >
          <template #prepend>
            <v-icon size="18">mdi-white-balance-sunny</v-icon>
          </template>
          <template #append>
            <v-icon size="18">mdi-weather-night</v-icon>
          </template>
        </v-switch>
      </div>
    </div>
  </v-app-bar>

  <!-- LINKER NAV DRAWER -->
  <v-navigation-drawer
    v-model="drawer"
    temporary
    class="navDrawer"
  >
    <v-list nav dense class="navList">
      <v-list-item
        prepend-icon="mdi-calendar"
        title="Dashboard"
        :to="'/Dashboard'"
        link
        exact
        active-class="active-nav-item"
      />
      <v-list-item
        prepend-icon="mdi-chart-bar"
        title="Statistiken"
        :to="'/Statistics'"
        link
        exact
        active-class="active-nav-item"
      />
      <v-list-item
        prepend-icon="mdi-home"
        title="INP-Live"
        class="listLastItem"
        href="https://inpcloud.sharepoint.com"
        target="_blank"
        rel="noopener noreferrer"
        tag="a"
      />
    </v-list>
  </v-navigation-drawer>

  <!-- ACCOUNT DRAWER (RECHTS, KOMPAKT) -->
  <v-navigation-drawer
    v-model="drawerAccount"
    location="right"
    temporary
    width="360"
    class="navDrawerAccount"
  >
    <AccountCard />
  </v-navigation-drawer>
</template>

<script>
import AccountCard from './AccountCard.vue'
import headerLogoLight from '/assets/img/inp-logo.svg'
import headerLogoDark from '/assets/img/inp-logo_weiss.png'
import { useTheme } from 'vuetify'
import { computed } from 'vue'

export default {
  components: {
    AccountCard,
  },

  setup() {
    const theme = useTheme()

    const isDark = computed({
      get: () => theme.global.name.value === 'dark',
      set: (val) => {
        const newTheme = val ? 'dark' : 'light'
        theme.global.name.value = newTheme
        localStorage.setItem('theme', newTheme)
      }
    })

    const headerLogo = computed(() =>
      isDark.value ? headerLogoDark : headerLogoLight
    )

    return { isDark, headerLogo }
  },

  data() {
    return {
      drawer: false,
      drawerAccount: false,
    }
  },

  methods: {
    toggleAccountDrawer() {
      this.drawerAccount = !this.drawerAccount
    },

    logout() {
      localStorage.removeItem('access_token')
      delete this.$axios.defaults.headers.common['Authorization']
      this.$router.push({ name: 'Auth' })
    }
  }
}
</script>

<style scoped>
/* APP BAR */
.appBar {
  margin-top: 15px;
  border-radius: 8px;
  align-items: center;
}

.appBarContent {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.leftSideContent {
  display: flex;
  align-items: center;
  margin-left: 12px;
  gap: 12px;
}
.INP-Logo {
  max-height: 25px;
  margin-left: 1vw;
}
/* RECHTS */
.rightSideContent {
  display: flex;
  align-items: center;
}
.theme-switch {
  margin-right: 12px;
}
.btn_Logout {
  margin-right: 12px;
}
/* DRAWER LINKS */
.navDrawer {
  margin-top: 25px;
  border-radius: 8px;
  height: max-content !important;
  overflow-y: auto;
}
/* ACCOUNT DRAWER */
.navDrawerAccount {
  margin-top: 25px;
  border-radius: 8px;

  /* ⭐ entscheidend */
  height: max-content !important;
  overflow-y: auto;
}
.navList {
  zoom: 115%;
}
.listLastItem {
  color: rgb(255, 102, 0) !important;
}
</style>
